import React from 'react';
import './Step0UserSetup.css';

const Step0UserSetup = ({ onNext }) => {
    return (
        <div className="step0-container">
            <div className="step0-content">
                <div className="step0-icon">
                    <img src="/icons/byte.png" alt="" className="step0-icon-image" />
                </div>
                
                <h1 className="step0-title">Welcome to AutoChef!</h1>
                
                <div className="step0-description">
                    <p className="step0-main-text">
                        AutoChef generates personalized weekly meal plans just for you.
                    </p>
                    
                    <div className="step0-features">
                        <div className="step0-feature">
                            <span className="feature-icon">👤</span>
                            <span className="feature-text">Tailored to your dietary needs</span>
                        </div>
                        <div className="step0-feature">
                            <span className="feature-icon">🌍</span>
                            <span className="feature-text">Your favorite cuisines</span>
                        </div>
                        <div className="step0-feature">
                            <span className="feature-icon">🥗</span>
                            <span className="feature-text">Respects your allergens</span>
                        </div>
                        <div className="step0-feature">
                            <span className="feature-icon">📅</span>
                            <span className="feature-text">Perfectly portioned for your week</span>
                        </div>
                    </div>
                    
                    <p className="step0-cta-text">
                        Let's set up your preferences to get started!
                    </p>
                </div>
                
                <button 
                    className="btn btn-primary btn-lg step0-button"
                    onClick={() => onNext()}
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

export default Step0UserSetup;

